const safeJsonParse = (jsonString) => {
  try {
    const parsedJson = JSON.parse(jsonString);
    return parsedJson;
  } catch (e) {
    return void 0;
  }
};

export { safeJsonParse };
//# sourceMappingURL=jsonUtils.js.map
